import CallApi from "../../util/CallApi";
import { data } from "../../mockData/_customer-mock";

export const FETCH_CUSTOMER = "FETCH_CUSTOMER";
export const FETCH_CUSTOMER_SUCCESS = "FETCH_CUSTOMER_SUCCESS";
export const FETCH_CUSTOMER_FAILURE = "FETCH_CUSTOMER_FAILURE";

export const UPDATE_CUSTOMER = "UPDATE_CUSTOMER";
export const UPDATE_CUSTOMER_SUCCESS = "UPDATE_CUSTOMER_SUCCESS";
export const UPDATE_CUSTOMER_FAILURE = "UPDATE_CUSTOMER_FAILURE";

export const CANCEL_ORDERS_CUSTOMER = "CANCEL_ORDERS_CUSTOMER";
export const CANCEL_ORDERS_CUSTOMER_SUCCESS = "CANCEL_ORDERS_CUSTOMER_SUCCESS";
export const CANCEL_ORDERS_CUSTOMER_FAILURE = "CANCEL_ORDERS_CUSTOMER_FAILURE";

const mockup = false;
const callApi = new CallApi();

export const fetchCustomer = params => dispatch => {
  dispatch({ type: FETCH_CUSTOMER });
  if (mockup) {
    return dispatch({ type: FETCH_CUSTOMER_SUCCESS, payload: data });
  } else {
    return callApi
      .post(
        "/customer",
        { project_id: params.project_id, customer_id: params.customer_id }
      )
      .then(res => {
        dispatch({ type: FETCH_CUSTOMER_SUCCESS, payload: res });
      })
      .catch(error => {
        dispatch({ type: FETCH_CUSTOMER_FAILURE, payload: error });
      });
  }
};

export const updateCustomer = values => dispatch => {
  dispatch({ type: UPDATE_CUSTOMER });
  if (mockup) {
    return dispatch({
      type: UPDATE_CUSTOMER_SUCCESS,
      payload: { customer_id: "cus001" }
    });
  } else {
    return callApi
      .post("/customer/update", values)
      .then(res => {
        return dispatch({ type: UPDATE_CUSTOMER_SUCCESS, payload: res });
      })
      .catch(error => {
        return dispatch({ type: UPDATE_CUSTOMER_FAILURE, payload: error });
      });
  }
};

export const updateOrdersEditCustomer = values => dispatch => {
  dispatch({ type: CANCEL_ORDERS_CUSTOMER });
  if (mockup) {
    return dispatch({
      type: CANCEL_ORDERS_CUSTOMER_SUCCESS,
      payload: { customer_id: "cus001" }
    });
  } else {
    return callApi
      .post("/customer/cancelorders", values)
      .then(res => {
        return dispatch({ type: CANCEL_ORDERS_CUSTOMER_SUCCESS, payload: res });
      })
      .catch(error => {
        return dispatch({
          type: CANCEL_ORDERS_CUSTOMER_FAILURE,
          payload: error
        });
      });
  }
};
